import React from 'react';
import InputField from '../common/Input';
import Select, { components } from 'react-select';
import { CBI_DOCUMENT_ACCEPTED_FORMATS } from '../../config/constant';
const { ValueContainer, Placeholder } = components;

const CbiCreditInformation = ({ editable, errors = {}, title, configList, basic_details = {}, handleInputChange = ()=>{}, handleChangeCbiDoc, handleRemoveCbiDoc, handleDocClick = ()=>{} }) => {
    let { current_loan_types = [], past_loan_types = [] } = configList;

    const CURRENT_LOAN_TYPE_OTHER_ID = 6;
    const PAST_LOAN_TYPE_OTHER_ID = 12;
    
    const getSelectedCurrentLoanType = () =>{
    if(basic_details?.current_loan_type_id === CURRENT_LOAN_TYPE_OTHER_ID ) return basic_details?.current_loan_type_others ?? "-";
    let selected = current_loan_types.find(ele=>ele.value === basic_details?.current_loan_type_id);
    if(selected) return selected.label
    return "-"
    }

    const getSelectedPastLoanType = () =>{
        if(basic_details?.past_loan_type_id === PAST_LOAN_TYPE_OTHER_ID ) return basic_details?.past_loan_type_others ?? "-";
        let selected = past_loan_types.find(ele=>ele.value === basic_details?.past_loan_type_id);
        if(selected) return selected.label
        return "-"
    }

  if(editable){
    return (
        <>
          <div className='cbi_info_wrapper'>
                <div className='field_wrapper'>
                    <fieldset>
                        <div className="material">
                            <InputField type="number" error={(errors.credit_score) ? errors.credit_score : ''} name="credit_score" id="credit_score" label="Credit Score" placeholder=" " value={basic_details.credit_score} onChange={handleInputChange.bind(null, 'credit_score', 'text')}  required={true} />
                            <label data-label="Credit Score" className="form-label"></label>
                        </div>
                    </fieldset>
    
                    <fieldset className=" single-select">
                        <div className="material">
                            <Select
                                components={{ ValueContainer: CustomValueContainer }}
                                options={current_loan_types}
                                value={current_loan_types.filter((e) => e.value === basic_details?.current_loan_type_id)}
                                onChange={handleInputChange.bind(null, 'current_loan_type_id', "select")}
                                placeholder="Current Loan Type"
                                className="react-select"
                                classNamePrefix="react-select"
                            />
                        </div>
                        {
                            (errors && errors?.current_loan_type_id) ? <span className="error show">{errors?.current_loan_type_id}</span> : ''
                        }
                    </fieldset>
    
                    {basic_details.current_loan_type_id === CURRENT_LOAN_TYPE_OTHER_ID ? <fieldset>
                        <div className="material">
                            <InputField type="text" error={(errors.current_loan_type_others) ? errors.current_loan_type_others : ''} name="current_loan_type_others" id="current_loan_type_others" label="Other Current Loan Type" placeholder=" " value={basic_details.current_loan_type_others} required={true} onChange={handleInputChange.bind(null, 'current_loan_type_others', 'text')} />
                            <label data-label="Other Current Loan Type" className="form-label"></label>
    
                        </div>
                    </fieldset> : null }
    
                    <fieldset>
                        <div className="material">
                            <InputField type="number" error={(errors.default_probability) ? errors.default_probability : ''} name="default_probability" id="default_probability" label="PD" placeholder=" " value={basic_details.default_probability} required={true} onChange={handleInputChange.bind(null, 'default_probability', 'text')} />
                            <label data-label="PD" className="form-label"></label>
    
                        </div>
                    </fieldset>
    
                    <fieldset className="single-select">
                        <div className="material">
                            <Select
                                components={{ ValueContainer: CustomValueContainer }}
                                options={past_loan_types}
                                value={past_loan_types.filter((e) => e.value === basic_details?.past_loan_type_id)}
                                onChange={handleInputChange.bind(null, 'past_loan_type_id', "select")}
                                placeholder="Past Loan Type"
                                className="react-select"
                                classNamePrefix="react-select"
                            />
                        </div>
                        {
                            (errors && errors.past_loan_type_id) ? <span className="error show">{errors.past_loan_type_id}</span> : ''
                        }
                    </fieldset>
    
                    {basic_details.past_loan_type_id === PAST_LOAN_TYPE_OTHER_ID ? <fieldset>
                        <div className="material">
                            <InputField type="text" error={(errors.past_loan_type_others) ? errors.past_loan_type_others : ''} name="past_loan_type_others" id="past_loan_type_others" label="Other Past Loan Type" placeholder=" " value={basic_details.past_loan_type_others} required={true} onChange={handleInputChange.bind(null, 'past_loan_type_others', 'text')} />
                            <label data-label="Other Past Loan Type" className="form-label"></label>
    
                        </div>
                    </fieldset> : null }
                </div>
                <div>
                    <div className="img-bx-select-opt" style={{width: 280}}>
                        <div className="image-bx cbi-img-bx" style={{width: '100%'}} >
                            {basic_details?.cbi_doc_url &&
                            <>
                                <i className='ic-clearclose' onClick={handleRemoveCbiDoc}></i>
                                <iframe
                                    
                                    src={basic_details.cbi_doc_url}
                                    title="CBI Document"
                                    width="100%"
                                    height="100%"
                                    style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                                />
                            </>
                            }
                            {!basic_details?.cbi_doc_url &&
                                <div className="image-bx more-file-upload">
                                    <i className='ic-add'></i>
                                    <input
                                        type="file"
                                        name="doc_title"
                                        accept={CBI_DOCUMENT_ACCEPTED_FORMATS}
                                        className="upload"
                                        onChange={handleChangeCbiDoc}
                                    />
                                    <p>Add Documents</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
          </div>
        </>
      );
  }

  return (
    <>
      {title ? <div className='top-heading d-flex'> <h2>{title}</h2> </div> : null}

      <div className='cbi_info_wrapper'>
            <div className='view_field_wrapper'>
                <div>
                    <h4>Credit Score:</h4>
                    <span>{basic_details?.credit_score ?? '-'}</span>
                </div>

                <div>
                    <h4>Current Loan Type: <br></br> (Collectability)</h4>
                    <span>{getSelectedCurrentLoanType()}</span>
                </div>

                <div>
                    <h4>PD:</h4>
                    <span>{basic_details?.default_probability ?? '-'}</span>
                </div>

                <div>
                    <h4>Past Loan Type: <br></br> (Collectability)</h4>
                    <span>{getSelectedPastLoanType()}</span>
                </div>
            </div>
            <div>
                <div className="img-bx-select-opt" style={{width: 280}}>
                    <div className="image-bx cbi-img-bx" style={{width: '100%'}}>
                        {basic_details?.cbi_doc_url &&
                        <>
                            <i className='ic-save' title='Download' onClick={handleDocClick}></i> 
                            <iframe
                                src={basic_details?.cbi_doc_url}
                                title="CBI Document"
                                width="100%"
                                height="100%"
                                style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                        </>
                        }
                        {!basic_details?.cbi_doc_url &&
                            <div className="image-bx more-file-upload">
                                <input
                                    disabled={true}
                                    type="file"
                                    name="doc_title"
                                    accept={CBI_DOCUMENT_ACCEPTED_FORMATS}
                                    className="upload"
                                    onChange={handleChangeCbiDoc}
                                />
                                <p>No preview available</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
      </div>
    </>
  );
};

export default CbiCreditInformation;


  const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                <Placeholder {...props} isFocused={props.isFocused}>
                    {props.selectProps.placeholder}
                </Placeholder>
                {React.Children.map(children, child =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };